import { MetricsPayload } from "api/ApiMetrics"
import { PeriodFilters } from "constants/metrics"

export const formatDate = (dateString: string) => {
  const date = new Date(dateString)

  const result = date.toLocaleDateString()

  return result
}

export const getDateDaysAgo = (days: number) => {
  const date = new Date()

  date.setDate(date.getDate() - days)
  date.setHours(0, 0, 0, 0)

  return date
}

export const formatMetricsDate = (params: MetricsPayload | App.MetricsParams) => {
  const payload = { ...params }

  if (!payload.dateEnd) payload.dateEnd = payload.dateStart

  return payload
}

export const getDateRangeByPeriod = (period: PeriodFilters): [Date, Date] => {
  const dateEnd = getDateDaysAgo(0)

  let dateStart: Date

  switch (period) {
    case PeriodFilters.SEVEN_DAYS:
      dateStart = getDateDaysAgo(6)
      break
    case PeriodFilters.FOURTEEN_DAYS:
      dateStart = getDateDaysAgo(13)
      break
    case PeriodFilters.THIRTY_DAYS:
    default:
      dateStart = getDateDaysAgo(29)
      break
  }

  return [dateStart, dateEnd]
}

export const getFirstDayOfMonth = (dateInput: string | Date = new Date()): Date => {
  const date = new Date(dateInput)

  date.setDate(1)
  date.setHours(0, 0, 0, 0)

  return date
}
